import { ShortenedWarranty } from './../../../models/shortened-warranty.model';
import { Warranty } from './../../../models/warranty.model';
import { GuarantiesService } from './../../../services/guaranties.service';
import { TenantsService } from './../../../services/tenants.service';
import { Tenant } from './../../../models/tenant.model';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { UtilsService } from '../../../services/utils.service';
import { ErrorResponse } from '../../../models/error.model';
import { ID } from '../../../models/ID.model';

@Component({
    selector: 'app-tenant-details',
    templateUrl: './tenant-details.component.html',
    styleUrls: ['./tenant-details.component.scss']
})
export class TenantDetailsComponent implements OnInit {

    tenant?: Tenant;
    guaranties?: ShortenedWarranty[];

    constructor(
        private tenantsService: TenantsService,
        private guarantiesService: GuarantiesService,
        private utilsService: UtilsService,
        private route: ActivatedRoute
    ) { }

    ngOnInit(): void {
        this.route.params.subscribe(params => {
            if (params.id) {
                this.getTenant(params.id);
                this.getGuaranties(params.id);
            }
        });
    }

    getTenant(id: ID) {
        this.tenantsService.getTenantById(id).subscribe(tenant => {
            this.tenant = tenant;
        }, (error: ErrorResponse) => this.utilsService.alert('Error al obtener detalles del inquilino', error.error?.descripcion));
    }

    getGuaranties(tenantId: ID) {
        this.guarantiesService.getGuarantees(0, 1000, [], { 'id-inquilino': tenantId }).subscribe(response => {
            this.guaranties = response.body;
        }, (error: ErrorResponse) => this.utilsService.alert('Error al obtener garantías del inquilino', error.error?.descripcion));
    }
}
